import Webshops from './components/Webshops/Webshops.vue'
import AccountCards from './components/AccountCards/AccountCards.vue'
import PrepaidCards from './components/PrepaidCards/PrepaidCards.vue'
import Withdraws from './components/Withdraws/Withdraws.vue'
import RevenueReport from './components/Report/RevenueReport.vue'
import SportsbookBets from './components/SportsbookBets/SportsbookBets.vue'
import MobileDashboard from './components/MobileDashboard/MobileDashboard.vue'
import Dashboard from './components/Dashboard/Dashboard.vue'
import Bonuses from './components/AccountCards/Bonuses.vue'
import CbcxTickets from './components/CbcxTickets/CbcxTickets.vue'
import SportsBookPayouts from './components/SportsBookPayouts/SportsBookPayouts.vue'
import GameVendorReport from './components/GameVendorReport/GameVendorReport.vue'
import UserStats from './components/UserStats/UserStats.vue'
import GeneralStatistics from './components/GeneralStatistics/GeneralStatistics.vue'

export const routes = [{
        name: 'Webshops',
        path: '/Webshops/:rm?',
        component: Webshops,
    },
    {
        name: 'Dashboard',
        path: '',
        component: Dashboard,
    },
    {
        name: 'Account Cards',
        path: '/AccountCards/:rm?',
        component: AccountCards,
    },
    {
        name: 'Bonuses',
        path: '/Bonuses',
        component: Bonuses,
    },
    {
        name: 'Prepaid Cards',
        path: '/PrepaidCards/:rm?',
        component: PrepaidCards,
    },
    {
        name: 'Withdraws',
        path: '/Withdraws/:rm?',
        component: Withdraws,
    },
    {
        name: 'Report',
        path: '/Report/:rm?',
        component: RevenueReport,
    },
    {
        name: 'Game Vendor Report',
        path: '/GameVendorReport/:rm?',
        component: GameVendorReport,
    },
    {
        name: 'User Statistics',
        path: '/UserStats/:rm?',
        component: UserStats,
    },
    {
        name: 'Report',
        path: '/Report/:rm?',
        component: RevenueReport,
    },
    {
        name: 'Sportsbook',
        path: '/Sportsbook/:betID/:cardID',
        component: SportsbookBets,
    },
    {
        name: 'Sportsbook Bets',
        path: '/Sportsbook/:rm?',
        component: SportsbookBets,
    },
    {
        name: 'M-Dashboard',
        path: '/MobileDashboard',
        component: MobileDashboard,
    },
    {
        name: 'CBCX Tickets',
        path: '/CbcxTickets/:rm?',
        component: CbcxTickets,
    },
    {
        name: 'Sportsbook Payouts',
        path: '/SportsBookPayouts/:rm?',
        component: SportsBookPayouts,
    },
    {
        name: 'General Statistics',
        path: '/GeneralStatistics/:rm?',
        component: GeneralStatistics,
    },
]